<div
        [class.has-timeout]="this.hasTimeout"
        [class]="'snackbar-' + this.modalData.snackbarType"
        class="snackbar">
    <div
            [attr.data-qa]="qaTag"
            [class.has-action]="modalData.actionTranslationKey"
            class="snackbar-content">
        <span [attr.data-qa]="qaTag + '-message'">{{ modalData.translationKey | translate: modalData.translateKeyParameters }}</span>
        @if (modalData.actionTranslationKey) {
            <app-button (clicked)="dismissWithAction()"
                        [appButtonType]="AppButtonTypeEnum.TEXT_ONLY_BUTTON"
                        [buttonText]="modalData.actionTranslationKey | translate"
                        [qaTag]="qaTag + '-button'"
                        class="snackbar-action-button"/>
        }
    </div>
    @if (this.hasTimeout) {
        <div [attr.data-qa]="qaTag + '-timeout-bar'"
             [style]="{'--animation-duration': this.timeoutInSeconds}"
             class="snackbar-timeout-bar"></div>
    }
</div>
